<div class="container-fluid">
  <h1>
    {{ 'contacts.contact-type.contact-type-label' | translate | titlecase }}
  </h1>

  <div class="form-horizontal">
    <div class="form-group">
      <div class="col-md-2">
        <input style="width:100%" type="text"
          placeholder="{{ 'contacts.contact-type.keyword-label' | translate | titlecase }}"
          [(ngModel)]="searchParams.Keyword" />
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-12">
        {{ 'contacts.contact-type.date-created-search-between-label' | translate | titlecase }}
        <input type="date" [(ngModel)]="searchParams.DateCreatedStart" />
        {{ 'common.to' | translate }}
        <input type="date" [(ngModel)]="searchParams.DateCreatedEnd" />
      </div>
    </div>
    <div class="form-group">
      <div class="col-md-12">
        {{ 'contacts.contact-type.date-changed-search-between-label' | translate | titlecase }}
        <input type="date" [(ngModel)]="searchParams.DateChangedStart" />
        {{ 'common.to' | translate }}
        <input type="date" [(ngModel)]="searchParams.DateChangedEnd" />
      </div>
    </div>
    <button pButton type="button" class="btn btn-default" (click)="loadContactTypes()">
      {{ 'contacts.contact-type.search-button' | translate | titlecase }}
    </button>
  </div>

  <p [hidden]="!loadingContactTypes"><wl-busy [show]="loadingContactTypes"></wl-busy> {{ 'common.loading' | translate |
    titlecase }}</p>

  <p [hidden]="loadingContactTypes || contactTypes?.length">
    {{ 'contacts.contact-type.no-contact-types' | translate | titlecase }}
  </p>

  <p-table [showGridlines]="true" #contactTypeDataGrid class="col-md-12" [lazy]="true" [rows]="10" [value]="contactTypes" [paginator]="true" (onLazyLoad)="lazyLoadContactTypes($event)" [totalRecords]="searchResult.TotalCount" [hidden]="loadingContactTypes || !contactTypes?.length">
    <ng-template pTemplate="sorticon" field="col.field" let-sortOrder>
      <SortAltIcon *ngIf="sortOrder === 0">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-alt" aria-hidden="true"></i></span>
      </SortAltIcon>
      <SortAmountUpAltIcon *ngIf="sortOrder === 1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-up-alt" aria-hidden="true"></i></span>
      </SortAmountUpAltIcon>
      <SortAmountDownIcon *ngIf="sortOrder === -1" [styleClass]="'p-sortable-column-icon'">
        <span><i class="p-sortable-column-icon pi pi-fw pi-sort-amount-down" aria-hidden="true"></i></span>
      </SortAmountDownIcon>
    </ng-template>
    <ng-template pTemplate="header">
      <tr>
        <th>{{ 'contacts.contact-type.contact-type-label' | translate | titlecase }}</th>
        <th>{{ 'contacts.contact-type.date-created-label' | translate | titlecase }}</th>
        <th>{{ 'contacts.contact-type.date-changed-label' | translate | titlecase }}</th>
      </tr>
    </ng-template>
    <ng-template pTemplate="body" let-type>
      <tr>
        <td>{{ type.ContactType }}</td>
        <td>{{ type.DateCreated }}</td>
        <td>{{ type.DateChanged }}</td>
      </tr>
    </ng-template>
  </p-table>

</div>